import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useIsMobile = () => {
	const theme = useTheme();
	const notMobile = useMediaQuery(theme.breakpoints.up('sm'));
	return !notMobile;
};

export default useIsMobile;
